import { create } from "zustand";

interface ChatTipTapEditorHeightStore {
  height: number;
  setHeight: (height: number) => void;
}

export const useChatTipTapEditorHeightStore =
  create<ChatTipTapEditorHeightStore>()((set) => ({
    height: 0,
    setHeight: (height) => set({ height }),
  }));
